import type { SVGProps } from 'react';
const SvgIconDisclosureDownSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.606 6.338a.75.75 0 0 1 1.058-.074L8 8.67l3.336-2.406a.75.75 0 1 1 .985 1.132l-3.829 3.33a.75.75 0 0 1-.984 0l-3.829-3.33a.75.75 0 0 1-.073-1.058"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconDisclosureDownSmall;
